import React, { useCallback, useState } from "react";
import { StyledContainer } from "./confirmationStyles";

const createPromise = () => {
  let resolver;
  return [
    new Promise((resolve, reject) => {
      resolver = resolve;
    }),
    resolver,
  ];
};

const useConfirm = () => {
  const [open, setOpen] = useState(false);
  const [resolver, setResolver] = useState({ resolver: null });
  const [label, setLabel] = useState("");

  const getConfirmation = useCallback(async (text) => {
    setLabel(text);
    setOpen(true);

    const [promise, resolve] = await createPromise();
    setResolver({ resolve });
    return promise;
  }, []);

  const c = useCallback(
    async (status) => {
      setOpen(false);
      resolver.resolve(status);
    },
    [resolver, open]
  );

  const Confirmation = useCallback(
    () => (
      <StyledContainer>
        <div
          className="overlay"
          style={{
            display: open ? "block" : "none",
          }}
        ></div>
        <div
          className="confirm"
          style={{
            display: open ? "block" : "none",
          }}
        >
          <div>{label}</div>
          <div className="buttons">
            <button className="cancel" onClick={() => c(false)}> Cancel </button>
            <button onClick={() => c(true)}> OK </button>
          </div>
        </div>
      </StyledContainer>
    ),
    [open, label, resolver]
  );

  return [getConfirmation, Confirmation];
};

export default useConfirm;
